import { render, staticRenderFns } from "./MembershipLogo.vue?vue&type=template&id=55483ca1&"
import script from "./MembershipLogo.vue?vue&type=script&lang=js&"
export * from "./MembershipLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports